import _extends from "reshow-runtime/es/helpers/extends";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";

/* jshint esnext: true */
import React from 'react';
import { mixClass } from 'class-lib';
import SemanticUI from '../molecules/SemanticUI';

var Rail = function Rail(props) {
  var attached = props.attached,
      left = props.left,
      others = _objectWithoutProperties(props, ["attached", "left"]);

  var classes = mixClass(props.className, 'rail', {
    left: left,
    attached: attached
  });
  return /*#__PURE__*/React.createElement(SemanticUI, _extends({}, others, {
    className: classes
  }));
};

Rail.defaultProps = {
  attached: true,
  left: true
};
export default Rail;